import { render, staticRenderFns } from "./RatesIntro.vue?vue&type=template&id=1212c4ad&scoped=true&"
import script from "./RatesIntro.vue?vue&type=script&lang=js&"
export * from "./RatesIntro.vue?vue&type=script&lang=js&"
import style0 from "./RatesIntro.vue?vue&type=style&index=0&id=1212c4ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1212c4ad",
  null
  
)

export default component.exports